export default __webpack_public_path__ + "static/media/envelope.8f75be36.svg";